import type { SVGProps } from "react";
export default function SvgPalette(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			className="lucide lucide-palette-icon lucide-palette"
			viewBox="0 0 24 24"
			{...props}
		>
			<path d="M12 22a1 1 0 0 1 0-20 10 9 0 0 1 10 9 5 5 0 0 1-5 5h-2.25a1.75 1.75 0 0 0-1.4 2.8l.3.4a1.75 1.75 0 0 1-1.4 2.8z" />
			<circle cx={13.5} cy={6.5} r={0.5} fill="currentColor" />
			<circle cx={17.5} cy={10.5} r={0.5} fill="currentColor" />
			<circle cx={6.5} cy={12.5} r={0.5} fill="currentColor" />
			<circle cx={8.5} cy={7.5} r={0.5} fill="currentColor" />
		</svg>
	);
}
